var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 9.83333C8.22667 9.83333 8 9.60667 8 9.33333V6C8 5.72667 8.22667 5.5 8.5 5.5C8.77333 5.5 9 5.72667 9 6V9.33333C9 9.60667 8.77333 9.83333 8.5 9.83333Z",
    fill: "#B32318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.49967 12C8.45967 12 8.41301 11.9933 8.36634 11.9866C8.32634 11.98 8.28634 11.9666 8.24634 11.9466C8.20634 11.9333 8.16634 11.9133 8.12634 11.8866C8.09301 11.86 8.05967 11.8333 8.02634 11.8066C7.90634 11.68 7.83301 11.5066 7.83301 11.3333C7.83301 11.16 7.90634 10.9866 8.02634 10.86C8.05967 10.8333 8.09301 10.8066 8.12634 10.78C8.16634 10.7533 8.20634 10.7333 8.24634 10.72C8.28634 10.7 8.32634 10.6866 8.36634 10.68C8.45301 10.66 8.54634 10.66 8.62634 10.68C8.67301 10.6866 8.71301 10.7 8.75301 10.72C8.79301 10.7333 8.83301 10.7533 8.87301 10.78C8.90634 10.8066 8.93967 10.8333 8.97301 10.86C9.09301 10.9866 9.16634 11.16 9.16634 11.3333C9.16634 11.5066 9.09301 11.68 8.97301 11.8066C8.93967 11.8333 8.90634 11.86 8.87301 11.8866C8.83301 11.9133 8.79301 11.9333 8.75301 11.9466C8.71301 11.9666 8.67301 11.98 8.62634 11.9866C8.58634 11.9933 8.53967 12 8.49967 12Z",
    fill: "#B32318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.54 14.7734H4.45998C3.15998 14.7734 2.16665 14.3 1.65998 13.4467C1.15998 12.5934 1.22665 11.4934 1.85998 10.3534L5.89998 3.08668C6.56665 1.88668 7.48665 1.22668 8.49998 1.22668C9.51332 1.22668 10.4333 1.88668 11.1 3.08668L15.14 10.36C15.7733 11.5 15.8466 12.5934 15.34 13.4534C14.8333 14.3 13.84 14.7734 12.54 14.7734ZM8.49998 2.22668C7.87332 2.22668 7.25998 2.70668 6.77332 3.57335L2.73998 10.8467C2.28665 11.66 2.21332 12.4067 2.52665 12.9467C2.83998 13.4867 3.53332 13.78 4.46665 13.78H12.5466C13.48 13.78 14.1666 13.4867 14.4866 12.9467C14.8066 12.4067 14.7266 11.6667 14.2733 10.8467L10.2267 3.57335C9.73998 2.70668 9.12665 2.22668 8.49998 2.22668Z",
    fill: "#B32318"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.47bd6ea8ff11f52bee1063d196822604.svg";
export { ForwardRef as ReactComponent };